module.exports = __webpack_public_path__ + "static/newark-4622013012e31ceeee82753b95940a8b.jpg";